module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Euro-29f878b2e209928315d539612572e94d.svg";